import Login from './views/Login.vue'
import UpdateTemporaryPassword from './views/UpdateTemporaryPassword.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import ForgotPasswordEmail from '@/shared/components/ForgotPasswordEmail.vue'
import ConfirmPasswordCode from '@/shared/components/ConfirmPasswordCode.vue'

export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
      layout: 'public',
    },
  },
  {
    path: '/update',
    name: 'UpdateTemporaryPassword',
    component: UpdateTemporaryPassword,
    meta: {
      auth: false,
      layout: 'public',
    },
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      auth: false,
      layout: 'public',
    },
    children: [
      {
        path: 'email',
        component: ForgotPasswordEmail,
      },
      {
        path: 'confirmCode',
        component: ConfirmPasswordCode,
      },
    ],
  },
]
